module.exports = __webpack_public_path__ + "static/img/arrow.9d74e1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/matchDetailOdds/assets/arrow.png
// module id = 672
// module chunks = 2